import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import RenderCartProp from '../RenderCartProp/RenderCartProp';
import './cartbox.scss';
import { BoxIcon, X, ShoppingCartIcon } from 'lucide-react';
import cloneDeep from 'lodash/cloneDeep';
import { usePrompt } from '../../context/PromptContext';
import { useNotification } from '../../context/NotificationContext';
import { useEffect } from 'react';
import 'animate.css';

const CartBox = () => {
 const navigate = useNavigate();
 const {
  cartData,
  updateOrder,
  deleteFromCart,
  isCartLoading,
  syncCart,
 } = useCart();
 const { notify } = useNotification();
 const { initPrompt } = usePrompt();

 useEffect(() => {
  (async () => {
   await syncCart(true);
  })();
  // eslint-disable-next-line
 }, []);

 const goTo = (page: string) => {
  navigate(page);
 };

 const handleQuantity = async (value: number, id: string) => {
  let clone = cloneDeep(cartData);

  let elem = clone.find((data) => {
   return data.id === id;
  });

  if (!elem) {
   return;
  }

  let newQ = elem.quantity + value;

  if (newQ < 1) {
   return;
  }

  if (newQ > elem.maxQuantity) {
   notify.error('Maximum quantity reached!');
   return;
  }

  let amount = (
   (elem.priceData.current_price as number) * newQ
  ).toFixed(2);

  elem.quantity = newQ;
  elem.totalAmount = parseFloat(amount);

  await updateOrder(elem);
 };

 const handleDelete = async (id: string) => {
  const callbackFunc = async () => {
   let resp = await deleteFromCart(id);
   if (resp) {
    notify.success('Item removed!');
   }
  };

  initPrompt(
   'Remove from cart?',
   'This product will be removed from your cart',
   callbackFunc,
  );
 };

 return (
  <div className="cartBox">
   {cartData.length >= 1 && (
    <div>
     <div className="cart-header">
      <div className="eachH">Products</div>
      <div className="eachH">Price</div>
      <div className="eachH">Quantity</div>
      <div className="eachH">Subtotal</div>
     </div>

     {isCartLoading && (
      <div className="cartloaderbox">
       <div className="cartloader"></div>
      </div>
     )}

     {!isCartLoading && (
      <div className="animate__animated animate__fadeIn animate__fast">
       {cartData.map((data, index) => (
        <div
         className="cart-item"
         key={index}
        >
         <div className="product-info">
          <div className="imageBox">
           {data.imgUrl && (
            <img
             src={data.imgUrl}
             className="image"
             alt="Product"
            ></img>
           )}
           {(!data.imgUrl || data.imgUrl === '') && (
            <BoxIcon
             size={40}
             strokeWidth={1}
             color="var(--gray-one)"
            ></BoxIcon>
           )}
          </div>

          <div className="textcontent">
           <div className="productname">{data.productName}</div>

           <div className="props">
            <div className="mobileprice">
             {data.priceData.currency_symbol}
             {data.priceData.current_price.toLocaleString()}
            </div>

            {data.selectedProperties?.map((data, index) => (
             <div
              className="eachprop"
              key={index}
             >
              <span className="proptitle">{data.name}:</span>
              <RenderCartProp
               type={data.type}
               value={data.value}
              ></RenderCartProp>
             </div>
            ))}

            {/* <div className='eachprop'> <span className='proptitle'>Color:</span> <span className='propvalue'>Black</span> </div> */}
           </div>
          </div>
         </div>

         <div className="eachdata">
          <div className="price productprice">
           {/* <span className='mobprice'>Price</span> */}
           <span>
            {data.priceData.currency_symbol}
            {data.priceData.current_price.toLocaleString()}
           </span>
          </div>
         </div>

         <div className="q_box eachdata">
          <div className="q_flex">
           <div
            className="q_btn"
            onClick={() => handleQuantity(-1, data.id)}
           >
            -
           </div>
           <div className="q_val">{data.quantity}</div>
           <div
            className="q_btn"
            onClick={() => handleQuantity(+1, data.id)}
           >
            +
           </div>
          </div>
         </div>

         <div className="eachdata deletesection">
          <div className="price subtotal">
           {/* <span className='mobsubtotal'>Sub Total</span> */}
           <span>
            {data.priceData.currency_symbol}
            {data.totalAmount.toLocaleString()}
           </span>
          </div>

          <div
           className="deletebtn"
           onClick={() => handleDelete(data.id)}
          >
           {!data.isUpdating && <X size={16}></X>}
           {data.isUpdating && <div className="smallspinner"></div>}
          </div>
         </div>
        </div>
       ))}
      </div>
     )}

     <hr className="line"></hr>
    </div>
   )}

   {!isCartLoading && cartData.length < 1 && (
    <div className="emptycart">
     <div className="idiv">
      <ShoppingCartIcon
       size={70}
       strokeWidth={1.5}
       className="bigcart"
      ></ShoppingCartIcon>
      <div className="text">Your cart is empty</div>
      <div className="btn-pack">
       <button
        className="fullbtn"
        onClick={() => goTo('/products')}
       >
        Continue Shopping
       </button>
      </div>
     </div>
    </div>
   )}
  </div>
 );
};

export default CartBox;
